import React from 'react';
import { render } from 'react-dom';
import Gallery from 'react-grid-gallery';
import Image from 'react-grid-gallery/lib/Image';
import styled from 'styled-components';
import { mediaQueries } from '../shared/config';

const Container = styled.div`
        display: flex;
        flex-direction: row;
        text-align: left; 
        justify-content: center; 
        width: 300px;
        /* margin-left: auto; */
        text-decoration: none !important;
        padding-left: 10px;
        
        ${mediaQueries.tablet} {
                flex-direction: column;
                padding-left: 0;
                text-align: center;
                padding-top: 20px;
                width: 80%;
        }
`;

const Images = styled.div`
        padding-right: 20px;
        text-decoration: none !important;
        ${mediaQueries.tablet} {
                padding-top: 30px;
        }
        a {
                div {
                        text-decoration: none !important;
                        /* text-align: left; */
                        ${mediaQueries.tablet} {
                                padding-bottom: 5px;
                        }
                        /* font-family: Poppins;
                        color: black;
                        font-weight: bold;
                        font-size: 12px;
                        text-align: left; */
                }

                text-decoration: none !important;
        }
        
`;

const IMG = styled.img`
        width: 300px;
        height: 200px;
        object-fit: cover;
        ${mediaQueries.tablet} {
                width: 100%;
        }
        ${mediaQueries.mobile} {
                width: 100%;
        }
`;

const NewsContainer = styled.div`
font-family: Poppins;
/* font-size: 14px; */
font-weight: bold;
font-size: 15px;
text-decoration: none !important;
color: black;
text-align: left;
padding-bottom: 5px;
${mediaQueries.tablet} {
        font-size: 18px;
/* padding-left: 10%; */
}
${mediaQueries.mobile} {
        /* padding-left: 10%; */
}
`

const ByLine = styled.div`
font-family: Poppins;
color: #4A4A4A;
font-weight: normal;
font-size: 12px;
text-decoration: none !important;
color: black;
text-align: left;
${mediaQueries.tablet} {
/* padding-left: 10%; */
}
${mediaQueries.mobile} {
        /* padding-left: 10%; */
}
`;

const Caption = styled.div`
        font-family: Poppins;
        color: black;
        font-weight: normal;
        font-size: 12px;
        text-align: left;
        ${mediaQueries.tablet} {
        /* padding-left: 10%; */
        font-size: 15px;
        }
        ${mediaQueries.mobile} {
        /* padding-left: 10%; */
}
`;

export default function GalleryGrid(props) {
        return(
                <Container>

                         <Images>
                         <a href={props.data[0].article_link}>
                                        <IMG src={props.data[0].image_link } alt="" />
                                        
                                                <NewsContainer> {props.data[0].section} </NewsContainer>
                                        
                                                
                                                <Caption>
                                                        {props.data[0].title}
                                                </Caption>
                                                <ByLine>{props.data[0].byline}</ByLine>
                                 </a>
                         </Images>

                         <Images>
                         <a href={props.data[1].article_link}>
                                        <IMG src={props.data[1].image_link } alt="" />
                                        
                                                <NewsContainer> {props.data[1].section} </NewsContainer>
                                       
                                                
                                                <Caption>
                                                        {props.data[1].title}
                                                </Caption>
                                                <ByLine>{props.data[1].byline}</ByLine>
                                 </a>
                         </Images>

                         <Images>
                         <a href={props.data[2].article_link}>
                                        <IMG src={props.data[2].image_link } alt="" />
                                        
                                                <NewsContainer> {props.data[2].section} </NewsContainer>
                                        
                                               
                                                <Caption>
                                                        {props.data[2].title}
                                                </Caption>
                                                <ByLine>{props.data[2].byline}</ByLine>
                                 </a>
                         </Images>

                         <Images>
                         <a href={props.data[3].article_link}>
                                        <IMG src={props.data[3].image_link } alt="" />
                                        
                                                <NewsContainer> {props.data[3].section} </NewsContainer>
                                        
                                                
                                                <Caption>
                                                        {props.data[3].title}
                                                </Caption>
                                                <ByLine>{props.data[3].byline}</ByLine>
                                 </a>
                         </Images>


                
 

                </Container>
        );
}
